import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import HeroSection from './landing/HeroSection';
import VisionSection from './landing/VisionSection';
import IntegratedComponentsHub from './landing/IntegratedComponentsHub';
import PrinciplesSection from './landing/PrinciplesSection';
import EarlyAccessSignup from './landing/EarlyAccessSignup';

interface LandingPageProps {
  onGetStarted?: () => void;
  onLogin?: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onGetStarted, onLogin }) => {
  const { t } = useTranslation('landing');

  return (
    <div className="min-h-screen bg-ink-50">

      {/* Hero Section */}
      <HeroSection onGetStarted={onGetStarted} onLogin={onLogin} />

      {/* Vision Section */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <VisionSection />
      </motion.div>

      {/* Integrated Components Hub */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <IntegratedComponentsHub />
      </motion.div>

      {/* Principles Section */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        viewport={{ once: true }}
      >
        <PrinciplesSection />
      </motion.div>

      {/* Early Access Signup */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
        viewport={{ once: true }}
      >
        <EarlyAccessSignup />
      </motion.div>
    </div>
  );
};

export default LandingPage;